<div class="tree-container" [ngClass]="{'loading': isLoading}">
    <div *ngIf="isLoading" class="loader-container">
        <twc-loader></twc-loader>
    </div>

    <twc-tree>
        <div *ngIf="hasHeader" class="width-100 tree-container-header twc-small">
            <div class="tree-container-button-headers">
                <span>
                    {{ 'AUTHORIZATION_USERS.FROM_GROUPS' |
                    translate}}</span>
                <span *ngFor="let button of extraButtons">
                    {{ button.header |
                    translate}}</span>
            </div>
        </div>
        <twc-tree-item *ngFor="let tree of list" [isExpanded]="isExpanded">
            <span>
                {{'PERMISSION_NAMES.' + tree.label | translate}}
            </span>
            <twc-tree-item *ngFor="let node of tree.nodes">
                <div class="twc-w-100 twc-d-flex twc-justify-content-between twc-align-items-center">
                    <div class="tree-item-text">
                        {{'PERMISSION_NAMES.' + node.label | translate}}
                    </div>
                    <div class="buttons-container">
                        <twc-checkbox>
                            <input twcCheckboxInput #checkedPermission [checked]="node.checked"
                                [disabled]="node.disabled || areChecksReadonly" (change)="onCheckboxChange(node)">
                        </twc-checkbox>
                        <twc-icon *ngFor="let button of extraButtons" class="twc-icon"
                            [shape]="getIconForceButton(button.type)" (click)="onExtraButtonClick(node, button.type)"
                            [class]="button.type" [ngClass]="{'disabled': isIconDisabled(node, button)}"
                            [size]="32"></twc-icon>
                    </div>
                </div>
            </twc-tree-item>
        </twc-tree-item>
    </twc-tree>
</div>